import {
  connect
} from 'react-redux';

import
React
  from 'react';

import {
  NavLink
} from 'react-router-dom';

import {
  Nav,
  Collapse
} from 'reactstrap';

// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from 'perfect-scrollbar';

//import avatar from 'assets/img/faces/ayo-ogunseinde-2.jpg';
//import avatar from 'assets/img/faces/user-icon.png';


import avatar from 'assets/img/user-icon.png';
import logo from 'assets/img/ordenexpress-logo.png';

import {
  OrdenExpressGetCurrentUser,
  OrdenExpressValidateSecurity,
} from 'orden_express/frameWork/frameWork';

var ps;

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getCollapseStates(props.routes);
    OrdenExpressValidateSecurity(this, false);
  }
  // this creates the intial state of this component based on the collapse routes
  // that it gets through this.props.routes
  getCollapseStates = routes => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: this.getCollapseInitialState(prop.views),
          ...this.getCollapseStates(prop.views),
          ...initialState
        };
      }
      return null;
    });
    return initialState;
  };
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.jsx - route /admin/regular-forms
  getCollapseInitialState(routes) {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.pathname.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  }
  // this function creates the links and collapses that appear in the sidebar (left menu)
  createLinks = (routes, pLastValue = 0) => {
    return routes.map((prop, key) => {
      if (prop.redirect || prop.hide) { //Mostrar solo las opciones que se pueden navegar en el menú
        return null;
      }
      if (prop.collapse) {
        var st = {};
        st[prop['state']] = !this.state[prop.state];
        return (
          <li
            className={this.getCollapseInitialState(prop.views) ? 'active' : ''}
            key={`li${key}-${pLastValue}`}
          >
            <a
              key={`enlace${key}-${pLastValue}`}
              href="#none"
              data-toggle='collapse'
              aria-expanded={this.state[prop.state]}
              onClick={e => {
                e.preventDefault();
                this.setState(st);
              }}
            >
              {prop.icon !== undefined ? (
                <>
                  <i className={prop.icon} />
                  <p>
                    {prop.name}
                    <b className='caret' />
                  </p>
                </>
              ) : (
                  <>
                    <span className='sidebar-mini-icon'>{prop.mini}</span>
                    <span className='sidebar-normal'>
                      {prop.name}
                      <b className='caret' />
                    </span>
                  </>
                )}
            </a>
            <Collapse
              isOpen={this.state[prop.state]}
              key={`Collapse${key}-${pLastValue}`}
            >
              <ul
                key={`ul${key}-${pLastValue}`}
                className='nav'>
                {this.createLinks(prop.views, key)}
              </ul>
            </Collapse>
          </li>
        );
      }
      return (
        <li className={prop.usingScript ? '' : this.activeRoute(prop.layout + prop.path)} key={key}>
          <NavLink to={prop.usingScript ? prop.usingScript : prop.layout + prop.path} activeClassName=''>
            {prop.icon !== undefined ? (
              <>
                <i className={prop.icon} />
                <p>{prop.name}</p>
              </>
            ) : (
                <>
                  <span className='sidebar-mini-icon'>{prop.mini}</span>
                  <span className='sidebar-normal'>{prop.name}</span>
                </>
              )}
          </NavLink>
        </li>
      );
    });
  };
  // verifies if routeName is the one active (in browser input)
  activeRoute = routeName => {
    return this.props.location.pathname.indexOf(routeName) > -1 ? 'active' : '';
  };
  componentDidMount() {
    // if you are using a Windows Machine, the scrollbars will have a Mac look
    if (navigator.platform.indexOf('Win') > -1) {
      ps = new PerfectScrollbar(this.refs.sidebar, {
        suppressScrollX: true,
        suppressScrollY: false
      });
    }
  }
  componentWillUnmount() {
    // we need to destroy the false scrollbar when we navigate
    // to a page that doesn't have this component rendered
    if (navigator.platform.indexOf('Win') > -1) {
      ps.destroy();
    }
  }



  processUserName(pData) {
    var result = pData;
    try {
      var localName = pData.replace('   ', ' ');
      localName = localName.replace('   ', ' ');
      localName = localName.split(' ');

      try {
        result = localName[0];
      } catch (__) { }
      try {
        result += ' ' + localName[1];
      } catch (__) { }
    } catch (__) { }
    return result;
  }

  renderGoOut = () => {
    return (
      <li className={''} key={'keysss'}>
        <a href="#_" 
        onClick={(event) => {
          this.props.callbackGetOut()
        }} className=''>
          <i className={'nc-icon nc-button-power'} />
          <p>{'Salir'}</p>
        </a>
      </li>
    );
  }
  render() {
    var localUser = OrdenExpressGetCurrentUser(this);
    return (
      <div
        className='sidebar mb-0 pb-0'
        data-color={this.props.bgColor}
        data-active-color={this.props.activeColor}
      >
        <div className='logo'>
          <div className='simple-text '>
            <a
              href='#OrdenExpress'
              className='logo-mini'
            >
              <img src={logo} alt='react-logo' />
            </a>
            <a
              href='#OrdenExpress'
              className='simple-text'
            >
              {'Orden Express'}
            </a>
          </div>
        </div>
        <div className='sidebar-wrapper' ref='sidebar'>

          <div className='user'>
            <div className='photo'>
              <img src={avatar} alt='Avatar' />
            </div>
            <div className='info'>
              <a
                href='#_'
                data-toggle='collapse'
                aria-expanded={this.state.openAvatar}
                onClick={() =>
                  this.setState({ openAvatar: !this.state.openAvatar })
                }
              >
                <span>
                  {localUser ? localUser.profile : ''}<br />
                  {this.processUserName(localUser ? localUser.name : '')}
                  <b className='caret' />
                </span>
              </a>
              <Collapse isOpen={this.state.openAvatar}>
                <ul className='nav'>
                  <li>
                    <a href='#_' 
                    onClick={(event)=>{
                      this.props.callbackGetOut()
                    }} className=''>
                      <i className='nc-icon nc-button-power text-white' />
                      <span className='sidebar-normal'>Salir</span>
                    </a>
                  </li>

                </ul>
              </Collapse>
            </div>
          </div>
          <Nav>
            {this.createLinks(this.props.routes)}
            {this.renderGoOut()}
          </Nav>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    loginReducerState: state.loginReducerState
  };
};

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);